"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionInfo = void 0;
var versionInfo = {
  buildTime: '2022-08-29T19:42:38Z',
  commit: 'd6a4e62ea0078f3fc6f46ef81e5f9df451281655',
  npmInfo: {
    'solid-ui': '2.4.22',
    npm: '8.18.0',
    node: '14.17.3',
    v8: '8.4.371.23-node.67',
    uv: '1.41.0',
    zlib: '1.2.11',
    brotli: '1.0.9',
    ares: '1.17.1',
    modules: '83',
    nghttp2: '1.42.0',
    napi: '8',
    llhttp: '2.1.3',
    openssl: '1.1.1k',
    cldr: '39.0',
    icu: '69.1',
    tz: '2021a',
    unicode: '13.0'
  }
};
exports.versionInfo = versionInfo;
//# sourceMappingURL=versionInfo.js.map